import React, { useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  Typography,
  Dialog,
  DialogContent,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import FoodProducts from "./FoodProducts";
import Beverages from "./Beverages";
import CleaningSolutions from "./CleaningSolutions";
import beverageIcon from "../Assets/beverages2.png";
import cleaningIcon from "../Assets/cleaning supplies2.png";
import foodIcon from "../Assets/food3.png";

export default function Products() {
  const [openFood, setOpenFood] = useState(false);
  const [openBeverages, setOpenBeverages] = useState(false);
  const [openCleaning, setOpenCleaning] = useState(false);

  const displayCard = (
    title,
    titleColor,
    description,
    open,
    setShow,
    thing,
    icon
  ) => {
    return (
      <Grid item xs={12} md={4}>
        <Card
          sx={{
            backgroundColor: "#ffffffff",
            color: "black",
            minHeight: 280,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            transition: "transform 0.3s, box-shadow 0.3s",
            "&:hover": {
              transform: "translateY(-8px)",
              boxShadow: "0 8px 20px rgba(0, 0, 0, 0.43)",
              // mt: -1,
            },
          }}
        >
          <CardContent
            sx={{
              flex: 1,
              width: { xs: 250, md: 350 },
              overflow: "hidden",
              p: 3,
              display: "flex",
              textAlign: "center",
              flexDirection: "column",
              fontSize: 8,
              justifyContent: "flex-start",
            }}
          >
            <Box sx={{ mb: 2 }}>
              <img src={icon} alt={`${title} icon`} style={{ height: 70 }} />
            </Box>
            <Typography
              variant="h5"
              gutterBottom
              sx={{
                color: titleColor,
                fontWeight: "bold",
                alignItems: "center",
                letterSpacing: 2,
                fontSize: { xs: "1.2rem", md: "1.5rem" },
              }}
            >
              {title}
            </Typography>
            <Typography
              variant="body1"
              fontFamily={"Roboto, sans-serif"}
              sx={{
                color: "#0c0c0cff",
                letterSpacing: 0,
                mt: 1,
                fontSize: { xs: "0.8rem", md: "1rem" },
              }}
            >
              {description}
            </Typography>
            <Button
              variant="contained"
              sx={{
                backgroundColor: "#009748",
                color: "#ffffffff",
                mt: 2,
                "&:hover": {
                  backgroundColor: "#28a062ff",
                },
              }}
              // onClick={handleClick}
              onClick={() => setShow(true)}
            >
              View Products
            </Button>
          </CardContent>
        </Card>
        <Dialog
          open={open}
          onClose={() => setShow(false)}
          maxWidth="sm"
          fullWidth
          PaperProps={{
            sx: {
              position: "relative",
              borderRadius: 3,
              // minHeight: "100vh",
            },
          }}
        >
          <IconButton
            aria-label="close"
            onClick={() => setShow(false)}
            sx={{
              position: "absolute",
              left: 8,
              top: 8,
              color: "#009748",
              zIndex: 1,
            }}
          >
            <CloseIcon />
          </IconButton>
          <DialogContent
            sx={{
              backgroundColor: "#ffffffff",
              p: 4,
              // display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {thing}
          </DialogContent>
        </Dialog>
      </Grid>
    );
  };
  return (
    <Box
      sx={{
        backgroundColor: "#ffffffff",
        minHeight: "40vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",

        px: 2,
        position: "relative",
      }}
    >
      <Grid
        container
        spacing={4}
        justifyContent="center"
        alignItems="stretch"
        sx={{
          display: "flex",
          flexWrap: "wrap",
          py: 4,
        }}
      >
        {displayCard(
          "Food Products",
          "#08b85dff",
          "Wholesome, delicious, and manufactured on demand for maximum freshness, quality and taste.",
          openFood,
          setOpenFood,
          <FoodProducts />,
          foodIcon
        )}

        {displayCard(
          "Beverage Range",
          "#42aec9ff",
          "Refresh, energise, and hydrate with our selection of beverages manufactured with fresh ingredients.",
          openBeverages,
          setOpenBeverages,
          <Beverages />,
          beverageIcon
        )}

        {displayCard(
          "Cleaning Solutions",
          "#ffcc00ff",
          "Effective, reliable, and cost-efficient cleaning products for domestic, commercial and industrial use.",
          openCleaning,
          setOpenCleaning,
          <CleaningSolutions />,
          cleaningIcon
        )}
      </Grid>

      <Typography
        variant="subtitle1"
        sx={{
          mt: 1,
          fontSize: { xs: "0.8rem", md: "1rem" },
          color: "#009748",
          textAlign: "center",
          maxWidth: 1400,
        }}
      >
        We distribute our products via reputable distributors in various market
        sectors and distribution channels. Should you wish to enquire about our
        products, find your closest distributor partner or apply to become a
        distributor, please contact our head office in Johannesburg.
      </Typography>
    </Box>
  );
}
